if (!customElements.get('sr-product')) {
  customElements.define('sr-product', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const image = this.querySelector('.main-product__image');
      const thumbnails = this.querySelectorAll('[data-product-thumbnail]');
      const select = this.querySelector('select[name="id"]');
      const radios = this.querySelectorAll('input[type="radio"][name="id"]');
      const selectedLabel = this.querySelector('[data-selected-variant-label]');
      const price = this.querySelector('[data-current-price]');
      const compare = this.querySelector('span[data-compare-price]');
      const add = this.querySelector('[name="add"]');
      const accelerated = this.querySelector('.main-product__accelerated-checkout');

      const showImage = (data) => {
        if (!image || !data.imageSrc) return;
        image.src = data.imageSrc;
        image.srcset = data.imageSrcset || '';
        image.alt = data.imageAlt || '';
        thumbnails.forEach((thumbnail) => {
          const active = thumbnail.dataset.mediaId === data.mediaId;
          thumbnail.classList.toggle('is-active', active);
          thumbnail.setAttribute('aria-pressed', String(active));
        });
      };

      thumbnails.forEach((thumbnail) => {
        thumbnail.addEventListener('click', () => showImage(thumbnail.dataset));
      });

      const selectedVariant = () => select?.selectedOptions[0] || this.querySelector('input[type="radio"][name="id"]:checked');

      const updateVariant = (updateUrl = false) => {
        const option = selectedVariant();
        if (!option) return;
        const data = option.dataset;
        price.textContent = data.price;
        compare.textContent = data.comparePrice;
        compare.hidden = data.onSale !== 'true';
        const available = data.available === 'true';
        add.disabled = !available;
        add.textContent = available ? this.dataset.addLabel : this.dataset.soldOutLabel;
        accelerated.hidden = !available;
        if (selectedLabel && data.label) selectedLabel.textContent = data.label;
        showImage(data);
        if (updateUrl) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', option.value);
          window.history.replaceState({}, '', url);
        }
      };

      select?.addEventListener('change', () => updateVariant(true));
      radios.forEach((radio) => radio.addEventListener('change', () => updateVariant(true)));
      updateVariant();
    }
  });
}
